import React from 'react';
import { Card, Form, InputNumber, Select, Button } from 'antd';
import { CalculatorOutlined } from '@ant-design/icons';

const { Option } = Select;

interface ReplenishmentCalculatorProps {
    targetDays: number;
    setTargetDays: (val: number) => void;
    salesDays: number;
    setSalesDays: (val: number) => void;
    onCalculate: () => void;
    loading: boolean;
}

export const ReplenishmentCalculator: React.FC<ReplenishmentCalculatorProps> = ({
    targetDays, setTargetDays, salesDays, setSalesDays, onCalculate, loading
}) => {
    return (
        <Card title="补货计算器">
            <Form layout="horizontal" labelCol={{ span: 8 }} wrapperCol={{ span: 16 }}>
                <Form.Item label="备货天数目标 (Cover Days)">
                    <InputNumber min={1} max={365} value={targetDays} onChange={(val) => setTargetDays(val || 60)} addonAfter="天" />
                </Form.Item>
                <Form.Item label="销量参考周期 (Sales Velocity)">
                    <Select value={salesDays} onChange={setSalesDays}>
                        <Option value={7}>过去 7 天</Option>
                        <Option value={14}>过去 14 天</Option>
                        <Option value={30}>过去 30 天</Option>
                        <Option value={60}>过去 60 天</Option>
                        <Option value={90}>过去 90 天</Option>
                    </Select>
                </Form.Item>
                <Form.Item wrapperCol={{ offset: 8 }}>
                    <Button type="primary" icon={<CalculatorOutlined />} onClick={onCalculate} loading={loading}>
                        开始计算
                    </Button>
                </Form.Item>
            </Form>
            <div style={{ marginTop: 16, textAlign: 'center', color: '#888' }}>
                点击“开始计算”生成建议
            </div>
        </Card>
    );
};
